var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTexture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.84 4L4 15.84V19.6133L19.6133 4H15.84ZM26.0133 4.10667L4.10667 26.0133C4.22667 26.4667 4.46667 26.88 4.78667 27.2133C5.12 27.5333 5.53333 27.7733 5.98667 27.8933L27.9067 5.98667C27.6533 5.06667 26.9333 4.34667 26.0133 4.10667ZM4 6.66667C4 5.2 5.2 4 6.66667 4H9.33333L4 9.33333V6.66667ZM25.3333 28C26.0667 28 26.7333 27.7067 27.2133 27.2133C27.7067 26.7333 28 26.0667 28 25.3333V22.6667L22.6667 28H25.3333ZM16.16 28H12.3867L28 12.3867V16.16L16.16 28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexture);
export default __webpack_public_path__ + "static/media/texture.004fb2069c60fa222215dd9ab34e02ef.svg";
export { ForwardRef as ReactComponent };